/**
 * The offline presentation build sets this before anything runs (see presentation/main.tsx): there is no backend to
 * talk to, so features that need a live connection (the alarm WebSocket) stay off.
 */
export const demoMode = { active: false };
